import React, { useMemo, useState } from "react";
import { fetchApiJson } from "../config/apiBase";
import { useI18n } from "../i18n/I18nContext";

const initialForm = {
  name: "",
  email: "",
  phone: "",
  message: "",
};

const labels = {
  en: {
    title: "Ask About This Service",
    name: "Your Name*",
    email: "Your Email*",
    phone: "Your Mobile Number*",
    message: "How can we help?",
    sending: "Sending...",
    submit: "Send Inquiry",
    success: "Your inquiry has been sent successfully.",
    failed: "We could not send your inquiry right now. Please try again.",
  },
  ar: {
    title: "استفسر عن هذه الخدمة",
    name: "الاسم*",
    email: "البريد الإلكتروني*",
    phone: "رقم الجوال*",
    message: "كيف يمكننا مساعدتك؟",
    sending: "جارٍ الإرسال...",
    submit: "إرسال الاستفسار",
    success: "تم إرسال استفسارك بنجاح.",
    failed: "تعذر إرسال استفسارك الآن. يرجى المحاولة مرة أخرى.",
  },
};

const ServiceInquiryForm = ({ serviceTitle, serviceSlug }) => {
  const { locale } = useI18n();
  const ui = labels[locale] || labels.en;
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [feedback, setFeedback] = useState({ type: "", message: "" });

  const resolvedServiceTitle = useMemo(
    () => serviceTitle || "Real Estate Service",
    [serviceTitle]
  );

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setFeedback({ type: "", message: "" });

    try {
      const { json } = await fetchApiJson("/api/services/inquiries", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...form,
          sourceTitle: resolvedServiceTitle,
          sourceSlug: serviceSlug,
        }),
      });

      if (!json?.success) {
        throw new Error(json?.message || ui.failed);
      }

      setForm(initialForm);
      setFeedback({ type: "success", message: ui.success });
    } catch (error) {
      setFeedback({
        type: "error",
        message: error?.message || ui.failed,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="widget ltn__form-widget">
      <h4 className="ltn__widget-title ltn__widget-title-border-2">{ui.title}</h4>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder={ui.name}
          value={form.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder={ui.email}
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="phone"
          placeholder={ui.phone}
          value={form.phone}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          placeholder={ui.message}
          value={form.message}
          onChange={handleChange}
          required
        />
        <button type="submit" className="btn theme-btn-1" disabled={submitting}>
          {submitting ? ui.sending : ui.submit}
        </button>
        {feedback.message ? (
          <p className={`mt-3 mb-0 ${feedback.type === "error" ? "text-danger" : "text-success"}`}>
            {feedback.message}
          </p>
        ) : null}
      </form>
    </div>
  );
};

export default ServiceInquiryForm;
